import content from 'content';
import { StepMetadata } from 'interfaces/store';

const metadata: StepMetadata = {
  id: 'done',
  title: content('page-title'),
  stepName: 'Done'
};

export default metadata;
